import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import Logo from "../../assets/SVG/logo.svg";

const Navbar = () => {
  return (
    <nav className="w-full flex justify-between items-center h-16 text-white mt-3">
      <div className="overflow-hidden">
        <div className="text-2xl sm:text-3xl">
          <img
            width="50"
            height="50"
            className="text-gray1 overflow-hidden"
            src={Logo}
            alt="Logo"
          />
        </div>
      </div>
      <div className="flex justify-between">
        <div className="m-2">
          <a
            href="https://github.com/aniketnegii"
            target="_blank"
            rel="noreferrer"
          >
            <GitHubIcon className="hover:text-yellow-300" fontSize="large" />
          </a>
        </div>
        <div className="m-2">
          <a
            href="https://www.linkedin.com/in/aniketnegi/"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedInIcon className="hover:text-yellow-300" fontSize="large" />
          </a>
        </div>
        <div className="m-2">
          <a
            href="https://twitter.com/aniket__negi"
            target="_blank"
            rel="noreferrer"
          >
            <TwitterIcon className="hover:text-yellow-300" fontSize="large" />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
